function toLocalString(uctDateTime, justDate= false) {
    var datetime = uctDateTime;
    if (uctDateTime && !uctDateTime.endsWith('Z')) {
        datetime = uctDateTime + "Z";
    }

    var theDate = new Date(Date.parse(datetime));
    var localString = theDate.toLocaleString();
    if (justDate) {

        var dateString = theDate.toLocaleDateString();
        return dateString;
    }

    return localString;
}

export default toLocalString;